/* eslint-disable no-new */
import { compose, withState, lifecycle, renderNothing } from 'recompose';

export const enhance = compose(
	withState('marker', 'setMarker', null),
	lifecycle({
		componentDidMount() {
			const {
				google,
				map,
				icon,
				label,
				labelClass,
				location,
				setMarker,
			} = this.props;
			if (google && map) {
				const marker = new google.maps.Marker({
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude,
					),
					map,
					icon,
					label,
					labelClass,
					zIndex: 100,
				});

				setMarker(marker);
			}
		},
		componentDidUpdate(prevProps) {
			const { google, location } = this.props;
			if (prevProps.location !== location) {
				const position = new google.maps.LatLng(
					location.latitude,
					location.longitude,
				);
				this.props.marker.setPosition(position);
			}
		},
		componentWillUnmount() {
			if (this.props.marker) {
				this.props.marker.setMap(null);
			}
		},
	}),
);

export default enhance(renderNothing());
